import React from 'react';

interface HorizontalScrollProps {
  children: React.ReactNode;
  className?: string;
  gap?: string;
  fadeFrom?: string;
}

export const HorizontalScroll: React.FC<HorizontalScrollProps> = ({
  children,
  className = '',
  gap = 'gap-3',
  fadeFrom = 'from-white',
}) => (
  <div className="relative">
    <div className={`flex ${gap} items-center overflow-x-auto scrollbar-none py-0.5 pr-10 ${className}`}>
      {children}
    </div>
    <div className={`absolute right-0 top-0 bottom-0 w-10 bg-gradient-to-l ${fadeFrom} to-transparent pointer-events-none`} />
  </div>
);
